<template>
  <section class="flex">
    <section class="common-sub-top container">
      <section class="top-info-wrap">
        <div class="prev-wrap">
          <a @click="pageBefore()" class="prev"></a>
          <span class="name">라이선스 현황</span>
        </div>

        <!-- <div class="select-wrap">
					<div class="select" @click="changeLicense">변경</div>
				</div> -->
      </section>
    </section>

    <section class="content license">
      <div>
        <div class="li" :class="{ used: liteUsed, active: liteActive }" @click="clickItem">
          <div class="left">
            <h1>Lite 버전</h1>
            <p>총 개수 : {{ this.licenseInfo[0].totalCnt }} / 사용중 : {{ this.licenseInfo[0].useCnt }}</p>
            <!-- <ul>
							<li>eghishealcare01</li>
							<li>eghis02</li>
							<li>eghis03</li>
							<li>eghis04</li>
						</ul> -->
          </div>
          <div class="right">
            <figure><img :src="require('@/assets/img/setting/ic-license-questionnaire.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-consent.png')" alt="" /></figure>
          </div>
        </div>
        <div class="li" :class="{ used: proUsed, active: proActive }" @click="clickItem">
          <div class="left">
            <h1>Pro 버전</h1>
            <p>총 개수 : {{ this.licenseInfo[1].totalCnt }} / 사용중 : {{ this.licenseInfo[1].useCnt }}</p>
            <!-- <ul>
							<li>eghis01</li>
							<li>eghis02</li>
							<li>eghis03</li>
							<li>eghis04</li>
						</ul> -->
          </div>
          <div class="right">
            <figure><img :src="require('@/assets/img/setting/ic-license-chart.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-questionnaire.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-consent.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-paitent.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-penchart.png')" alt="" /></figure>
            <figure><img :src="require('@/assets/img/setting/ic-license-photo.png')" alt="" /></figure>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      liteUsed: true,
      liteActive: true,
      proUsed: false,
      proActive: false,
      licenseInfo: [
        {
          procType: '',
          TotalCnt: 0,
          UseCnt: 0
        },
        {
          procType: '',
          TotalCnt: 0,
          UseCnt: 0
        }
      ]
    };
  },
  created() {
    if (this.$route.params.currentLicense === 'Pro') {
      this.proUsed = true;
      this.proActive = true;
      this.liteUsed = false;
      this.liteActive = false;
    } else {
      this.proUsed = false;
      this.proActive = false;
      this.liteUsed = true;
      this.liteActive = true;
    }

    try {
      //let url = `http://tab.eghishc.co.kr:7779/ws/api/auth/status/${this.$store.state.storeHospNo}/proc/tablet`;
      let url = `https://tab.eghishc.co.kr/ws/api/auth/status/${this.$store.state.storeHospNo}/proc/tablet`;
      axios
        .get(url)
        .then((response) => {
          this.licenseInfo = response.data.data;
        })
        .catch((e) => {
          alert(e);
        });
    } catch (e) {
      alert('여기');
      alert(e);
    }
  },
  methods: {
    pageBefore() {
      this.$router.go(-1);
    },
    clickItem() {
      //this.liteActive = !this.liteActive;
      //	this.proActive = !this.proActive;
    }
    // changeLicense() {
    // 	// 라이선스 변경
    // }
  }
};
</script>

<style scoped src="../../assets/css/setting.css"></style>
